import React from 'react';
import DOMPurify from 'dompurify';

type CleanedHtmlProps = {
  as?: React.ElementType<any>;
  className?: string;
}

// Allow links to have the target attribute
// https://github.com/cure53/DOMPurify/issues/317#issuecomment-470429778
DOMPurify.setConfig({ ADD_ATTR: ['target'] });

function createMarkup({ children }) {
  return { __html: DOMPurify.sanitize(children) };
}

function CleanedHtml(props: React.PropsWithChildren<CleanedHtmlProps>) {
  if (typeof props.children === 'string') {
    const { as: Component, children, className } = props;
    // Creates a dynamic element based on the "as" prop.
    // Sanitizes and set dangerous inner html.
    return (
      <Component
        className={className}
        dangerouslySetInnerHTML={createMarkup({ children })}
      />
    );
  }

  // Return a React element by wrapping children in a fragment
  return <>{props.children}</>;
}

CleanedHtml.defaultProps = {
  as: 'div',
};

export default React.memo(CleanedHtml);
